import { DocumentReceiptEntity } from '../../../generated-api';
import { CSVConvertResult, ResultPageDocument } from '../defs/types';
import { receiptsToCsv } from './receiptsToCsv';

export function convertReceiptCsv(data: ResultPageDocument<DocumentReceiptEntity>[]): CSVConvertResult {
  const receipts = data
    .filter((item) => !item.error)
    .map((item) => {
      return {
        summary: {
          ファイル名: item.parsed_path.fullFileName,
          ページ数: item.page?.toString() ?? '-',
          支払い日付: item.latest_revision.payment_date ?? '',
          摘要: item.latest_revision.payee?.[0] ?? '',
          事業者番号: item.latest_revision.business_number ?? '',
        },
        latest_revision: item.latest_revision,
      };
    });
  return receiptsToCsv(receipts);
}
